module.exports = __webpack_public_path__ + "img/android-select@3x.885731d0.png";